import BaseService from "../BaseService";
import _ from "lodash";

class UserService extends BaseService {
    list = async () => {
        var data = await this._api.get("/user/list");
        return data;
    };


    getByPhone = async (phone) => {
        var data = await this._api.post("/user/getbyphone", { phone });
        return data;
    };

    checkPhoneCanInvite = async (phone) => {
        var data = await this._api.post("/user/checkphonecaninvite", { phone });
        return data;
    };




    invite = async ({ user_id, permissions, role }) => {
        var data = await this._api.post("/user/invite", { user_id, permissions, role });
        return data;
    }


    getInviteList = async () => {
        var data = await this._api.get("/user/getinvitelist");
        return data;
    }



    cancelInvite = async (id) => {
        var data = await this._api.post("/user/cancelinvite", { id });
        return data;
    }




    acceptInvite = async (id) => {
        var data = await this._api.post("/user/acceptinvite", { id });
        return data;
    }



    getWorkSpaces = async () => {
        var data = await this._api.post("/user/getworkspaces");
        return data;
    }


    removeUser = async (user_id) => {
        var data = await this._api.post("/user/removeuser", { user_id });
        return data;
    }


    updateUserRole = async (data) => {
        var data = await this._api.post("/user/updateuserrole", data);
        return data;
    }





}
export default UserService;
